import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Distribution } from '@pulpo/pulpo-models';
import { APP_CONFIG } from '@pulpo/app-config';
import ApiService from '../api.service.abstract';

@Injectable({ providedIn: 'root' })
export class DistributionService extends ApiService<Distribution> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'distribution/api/distributions');
    if (environment.name == 'localDev') {
      this.url = 'http://localhost:8094';
    }
  }
}
